import Swiper, {Navigation, Pagination, EffectFade, Autoplay} from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

export default Swiper;



// WEBPACK FOOTER //
// ./scripts/autoload/_swiper.js